<template>
	<div class="alert_bg">
		<div class="alert_body">
			<div class="cancel_btn" @click="onCancelClick"></div>
			<div class="warn_icon"></div>
			<div class="warn_title">成功开启小宝积分</div>
			<div class="warn_tips" v-if="false">
				预计每月产生20000-30000积分<br />
				可兑换20-30元等值商品
			</div>
			<div class="pay_btn" @click="onSureClick">确定</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onCancelClick: function () {
			this.$emit("onCancelClick");
		},
		onSureClick: function () {
			this.$emit("onSureClick");
		},
	},
};
</script>

<style lang="less" scoped>
.alert_bg {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
	.alert_body {
		width: 280px;
		height: 280px;
		left: 50%;
		top: 50%;
		margin-left: -140px;
		margin-top: -140px;
		background-color: #ffffff;
		position: absolute;
		border-radius: 5px;
		.cancel_btn {
			position: absolute;
			right: 20px;
			top: 15px;
			height: 20px;
			width: 20px;
			background-image: url(../../assets/speedShare/close_icon.png);
			background-size: 100% 100%;
		}
		.cancel_btn:hover {
			cursor: pointer;
			opacity: 0.8;
		}
		.warn_icon {
			margin: 0 auto;
			margin-top: 50px;
			height: 58px;
			width: 58px;
			background-size: 100% 100%;
			background-image: url("../../assets/speedShare/success_icon.png");
		}
		.warn_title {
			margin-top: 30px;
			font-weight: bolder;
			color: #1a1a1a;
			font-size: 17px;
			text-align: center;
		}
		.warn_tips {
			color: #999999;
			font-size: 12px;
			width: 235px;
			margin: 0 auto;
			margin-top: 10px;
			line-height: 20px;
			text-align: center;
			font {
				color: #daae84;
			}
		}

		.pay_btn {
			width: 98px;
			height: 38px;
			line-height: 38px;
			color: #ffffff;
			background: #1f5de3;
			border-radius: 19px;
			opacity: 1;
			text-align: center;
			margin: 0 auto;
			margin-top: 50px;
		}
		.pay_btn:hover {
			opacity: 0.9;
			cursor: pointer;
		}
	}
}
</style>